<template>
  <div class="newsDscription ">
    <div class="page-help content">
      <template v-if="onenews">
        <h1 class="titleNews">
          {{ onenews.new_title }}
          <ShareNetworks
            v-if="onenews.new_title"
            :url="createUrl($route.params.id)"
            :title="onenews.new_title"
            :position="windowWidth > 1580 ? 'vertically' : 'horizontally'"
            class="set-position-social"
          />
        </h1>
        <p class="newsdate">
          <img
            src="@/assets/newImges/calendar-solid-light.svg"
            alt=""
            srcset=""
          />
          <span>{{ onenews.new_date }}</span> |
          <span class="autor">@ {{ onenews.new_author }}</span>
        </p>
        <div class="imgNews"><img :src="imageLink(onenews.main_image)" /></div>

        <div class="description" v-html="onenews.new_article"></div>
        <div class="more">
          <div v-if="onenews.links && onenews.links.length > 0">
            {{ $t("news.moreLinks") }}
          </div>
          <!-- <a href="https://www.facebook.com/eberza.rs" class="links"
            >https://www.facebook.com/eberza.rs</a
          > -->
          <a
            v-for="(link, index) in onenews.links"
            :key="index"
            :href="link.link"
            class="links"
            target="_blank"
            >{{ link.text ? link.text : link.link }}</a
          >
        </div>
      </template>
      <template v-else>
        <div class="wrapp-spiner">
          <img
            :src="require('@/assets/images/loader.gif')"
            alt=""
            class="spiner-img"
          />
        </div>
      </template>

      <!-- <ShareNetwork
          v-if="onenews.new_title"
          network="Facebook"
          :url="createUrl($route.params.id)"
          :title="onenews.new_title"
          :description="onenews.new_article"
          :quote="onenews.new_article"
          hashtags="eBerza"
        >
          <img
            style="cursor: pointer; margin-right: 5px"
            :src="require('@/assets/icons/facebook.png')"
            alt="facebook logo"
          />
        </ShareNetwork> -->
    </div>
  </div>
</template>

<script>
import { api, baseURL } from "@/api";
import ShareNetworks from "../components/shared/ShareNetworks.vue";
export default {
  name: "NewsDescriptionPage",
  components: { ShareNetworks },
  data() {
    return {
      onenews: null,
      windowWidth: window.innerWidth
    };
  },
  methods: {
    imageLink(image) {
      return baseURL + image;
    },
    getNewsInfo() {
      let id = this.$route.params.id;
      api
        .getNewsInfo(id)
        .then(res => {
          this.onenews = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    createUrl(id) {
      return (
        document.location.origin +
        "/" +
        this.$i18n.locale +
        "/news-description/" +
        id
      );
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    }
  },

  mounted() {
    // setTimeout(() => {
    //   this.getNewsInfo();
    // }, 1000);
    this.getNewsInfo();
    window.addEventListener("resize", this.onResize);
  },
  activated() {
    this.getNewsInfo();
  },
  deactivated() {
    this.onenews = null;
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  }
  // watch: {
  //   "$route.params.id": {
  //     handler: function() {
  //       // this.getNewsInfo();
  //     }
  //   }
  // }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/modalStyles.scss";
@import "@/assets/scss/scrollbarStyles.scss";

.set-position-social {
  position: absolute;
  top: 68px;
  right: -120px;
}

.newsDscription {
  font-family: Outfit;
  text-align: left;
  width: 100%;
  min-height: 100vh;
  .content {
    padding: 68px 0 106px 0;
    position: relative;
  }

  .titleNews {
    box-sizing: border-box;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 36px;
    line-height: 66px;
    letter-spacing: 0%;
    color: $blue-1000;
    margin: 0;
    margin-bottom: 37px;
  }
  .newsdate {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 32px;
    letter-spacing: 0%;

    color: $gray-blue-1300;
    display: flex;
    align-items: center;
    margin: 0;
    margin-bottom: 37px;
    span {
      margin: 0 20px;
    }

    img {
      margin-right: 17px;
    }
  }
  .autor {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 32px;
    letter-spacing: 0%;

    color: $light-blue-600;
  }
  .imgNews {
    margin: 3% 0;
    width: 100%;
    /* height: 70%; */
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: 507px;
    border: 1px solid $gray-blue-700;
    border-radius: 12px;

    img {
      /* object-fit: cover;
              position: absolute;
              display:block; */
      width: 100%;
    }
  }

  .description,
  .more {
    font-weight: 400;
    font-style: Regular;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0%;

    color: $blue-400;
    margin-bottom: 37px;
  }
  .links {
    font-weight: 400;
    font-style: Regular;
    font-size: 20px;

    line-height: 30px;
    letter-spacing: 0%;
    color: $light-blue-600;
    display: block;
  }
}
@media only screen and(max-width: 1580px) {
  h1 {
    max-width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  .set-position-social {
    // position: absolute;
    // top: 68px;
    // right: 0px;
    position: initial;

    width: fit-content;
  }
}
@media only screen and (max-width: 850px) {
  .imgNews {
    margin: 3% 0;
    width: 100%;
    max-height: 50%;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;

    img {
      object-fit: cover;
      /* position: absolute;
              display:block; */
      width: 100%;
    }
  }
}
@media only screen and (max-width: 750px) {
  .imgNews {
    margin: 1% 0;
    width: 100%;
    max-height: 50%;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;

    img {
      object-fit: cover;
      /* position: absolute;
              display:block; */
      width: 100%;
    }
  }
  .newsDscription {
    .newsdate {
      font-size: 14px;
      line-height: 22px;
      img {
        //   width: 15px;
        margin-right: 5px;
      }
    }
    .autor {
      font-size: 14px;
      line-height: 22px;
    }

    .description,
    .more {
      font-weight: 400;
      font-style: Regular;
      font-size: 18px;
      line-height: 22px;
      letter-spacing: 0%;

      margin-bottom: 37px;
    }

    .links {
      font-weight: 400;
      font-style: Regular;
      font-size: 18px;

      line-height: 22px;
    }
  }
}
@media only screen and (max-width: 650px) {
  .imgNews {
    margin: 1% 0;
    width: 100%;
    max-height: 40%;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;

    img {
      object-fit: cover;
      /* position: absolute;
              display:block; */
      width: 100%;
    }
  }
  .newsDscription {
    .newsdate {
      font-size: 14px;
      line-height: 22px;
      img {
        //   width: 15px;
        margin-right: 5px;
      }
      span {
        margin: 0 5px;
      }
      .autor {
        min-width: 50px;
      }
    }
  }
}
.wrapp-spiner {
  text-align: center;
}
.spiner-img {
  width: 100px;
}
</style>
